import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.reduce.js";
var CryptoJS = require('crypto-js');
var dbDataHandle = function dbDataHandle(num) {
  var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  try {
    if (isNaN(num) || num === -Infinity || num === Infinity || num === null || num === undefined || num === false || num < 0) return 0;
    // num = 0.024
    var strNum = typeof num === 'string' ? num : num.toString(); // '0.024'
    var dotIndex = strNum.indexOf('.') + 1; // 2
    var result = '';
    var i = 0;
    var j = '';
    var autoSettingPos = function autoSettingPos() {
      var numAfterDot = strNum.slice(dotIndex, to + dotIndex); // '02'
      if (num > 0 && num < 1 && Number(numAfterDot) === 0) {
        to++;
        autoSettingPos();
      }
    };
    autoSettingPos();

    // 10.15
    for (i; i < strNum.length; i++) {
      if (strNum[i] !== '.') {
        result += strNum[i];
      } else {
        result += to === 0 ? '' : strNum[i];
        j = i;
      }
      if (i === j + to) break;
    }
    return result * 1;
  } catch (err) {
    console.log(err);
    return 0;
  }
};
var handleIRRArray = function handleIRRArray(irr) {
  var type = Object.prototype.toString.call(irr).slice(8, -1).toLowerCase();
  if (irr === undefined || irr === null) return;
  if (type && type === 'number') return irr;
  if (type && type === 'array') return irr.length ? irr.reduce(function (a, b) {
    return a + b;
  }) / irr.length : irr;
  if (type && type === 'object') return irr.avg ? irr.avg : 0;
};
var timeDiffNow = function timeDiffNow(time) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'minutes';
  var now = DateTime.local();
  var dataTime = DateTime.fromISO(time).minus({
    hour: 8
  }); // diff() has bug so we -8h

  return now.diff(dataTime, unit).toObject();
};

/**
 *
 * @param {object} stateData state.factoryData []object
 * @param {object} updateData telemetry data single factory data object
 * @param  {string} args data arguments key and will be updating factoryData
 */
var updateFactoryData = function updateFactoryData(stateData, updateData) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  for (var _i = 0, _args = args; _i < _args.length; _i++) {
    var arg = _args[_i];
    stateData[arg] = updateData.detail[arg];
  }
};
var calculatePR = function calculatePR(cap, acp, IRR) {
  if (cap && !isNaN(acp) && !isNaN(IRR)) {
    var sumCap = cap.reduce(function (a, b) {
      return a + b;
    });
    var powerHour = dbDataHandle(acp / sumCap);
    var irr = dbDataHandle(IRR);
    var PR = dbDataHandle(dbDataHandle(powerHour / irr) * 100, 0);
    if (PR >= 100) PR = 100;
    return PR;
  } else return 0;
};
var decryptData = function decryptData(data) {
  var secret = process.env.VUE_APP_ENCRYPT_SECRET;
  var decryptBytes = CryptoJS.AES.decrypt(data, secret);
  return JSON.parse(decryptBytes.toString(CryptoJS.enc.Utf8));
};
export { dbDataHandle, timeDiffNow, updateFactoryData, calculatePR, handleIRRArray, decryptData };